import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '../cn';

type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

export const Label = forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn('text-sm font-medium text-fg-primary block', className)}
    {...props}
  />
));
Label.displayName = 'Label';
